<div class="callout" [ngClass]="['callout-' + variant(), dense() ? 'callout-dense' : '']">
  <mat-icon class="callout-icon" *ngIf="icon()">{{ icon() }}</mat-icon>

  <div class="callout-body">
    <span class="callout-title" *ngIf="title()">{{ title() }}</span>
    <span class="callout-description" *ngIf="description()">{{ description() }}</span>
    <ng-content></ng-content>
  </div>
</div>
